import { render } from "./quotation_remark.vue?vue&type=template&id=47f1a2a7"
import script from "./quotation_remark.vue?vue&type=script&lang=js"
export * from "./quotation_remark.vue?vue&type=script&lang=js"

import "./quotation_remark.vue?vue&type=style&index=0&id=47f1a2a7&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__